<template>
  <div class="page-content">
    <main class="container mx-auto py-8 px-4">
      <!-- 头部区域 -->
      <header class=" bg-gradient-primary header-gradient text-white py-20 px-6 md:px-12">
        <div class="max-w-5xl mx-auto text-center">
          <h1 class="text-4xl md:text-5xl font-bold mb-6">招投标信息</h1>
          <div class="text-lg text-white/90 max-w-3xl mx-auto">
            <p>实时更新会展项目招标与投标信息，提供项目详情、截止日期及联系方式。</p>
          </div>
        </div>
      </header>

      <!-- 二级菜单 -->
      <div class="nav-buttons-container flex justify-center space-x-6 mb-8">
        <div class="nav-button active">
          <i class="fas fa-file-contract"></i>
          <span>招标信息</span>
          <p>查看最新招标项目及详情</p>
        </div>
        <div class="nav-button">
          <i class="fas fa-trophy"></i>
          <span>中标公示信息</span>
          <p>了解项目中标结果及公告</p>
        </div>
        <div class="nav-button">
          <i class="fas fa-exclamation-triangle"></i>
          <span>风险提示</span>
          <p>获取招投标风险预警信息</p>
        </div>
      </div>

      <!-- 搜索栏 -->
      <div class="search-bar mb-6">
        <div class="flex items-center">
          <div class="relative flex-grow">
            <input type="text" placeholder="搜索招标项目关键词" class="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent">
            <i class="fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
          </div>
          <button class="ml-4 px-6 py-2 bg-blue-800 text-white rounded-lg hover:bg-blue-900 transition-colors">
            搜索
          </button>
        </div>
      </div>

      <!-- 筛选栏 -->
      <div class="filter-bar mb-6">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">省份</label>
            <select class="w-full px-4 py-2 border border-gray-300 rounded-lg select-style focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent">
              <option value="">全部省份</option>
              <option value="guangdong">广东省</option>
              <option value="jiangsu">江苏省</option>
              <option value="zhejiang">浙江省</option>
              <option value="shanghai">上海市</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">城市</label>
            <select class="w-full px-4 py-2 border border-gray-300 rounded-lg select-style focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent">
              <option value="">全部城市</option>
              <option value="shenzhen">深圳市</option>
              <option value="guangzhou">广州市</option>
              <option value="dongguan">东莞市</option>
              <option value="foshan">佛山市</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">会展招标内容</label>
            <select class="w-full px-4 py-2 border border-gray-300 rounded-lg select-style focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent">
              <option value="">全部内容</option>
              <option value="equipment">设备采购</option>
              <option value="service">服务外包</option>
              <option value="construction">工程建设</option>
              <option value="consulting">咨询服务</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">状态</label>
            <select class="w-full px-4 py-2 border border-gray-300 rounded-lg select-style focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent">
              <option value="">全部状态</option>
              <option value="active">招标中</option>
              <option value="expired">已截止</option>
            </select>
          </div>
        </div>
        <div class="mt-4 flex justify-between items-center">
          <div class="text-sm text-gray-600">共找到 <span class="font-semibold text-blue-800">246</span> 条相关信息</div>
          <div class="flex items-center">
            <span class="text-sm text-gray-600 mr-2">排序方式：</span>
            <select class="px-3 py-1 border border-gray-300 rounded-lg text-sm select-style focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent">
              <option value="publishTime">按发布时间</option>
              <option value="deadline">按截止日期</option>
              <option value="amount">按标的金额</option>
            </select>
          </div>
        </div>
      </div>

      <!-- 结果展示区 -->
      <div class="result-list">
        <!-- 招标信息卡片 1 -->
        <div class="result-card">
          <div class="status-badge active">招标中</div>
          <h2 class="text-xl font-bold text-blue-800 mb-2">2024年国际电子信息产业博览会展览服务项目</h2>
          <div class="mb-3">
            <span class="category-tag">展览服务</span>
            <span class="category-tag">会展策划</span>
          </div>
          <p class="text-gray-600 mb-4">本项目为2024年国际电子信息产业博览会提供整体展览服务，包括展位设计与搭建、展会现场管理、嘉宾接待、媒体宣传等全方位服务。展会预计吸引超过500家企业参展，观众人数将达到5万人次。</p>
          <div class="flex flex-wrap items-center justify-between">
            <div class="flex flex-wrap items-center mb-2 md:mb-0">
              <div class="mr-6 mb-2 md:mb-0">
                <span class="text-gray-600">发布单位：</span>
                <span class="font-medium">深圳市电子信息行业协会</span>
              </div>
              <div class="mr-6 mb-2 md:mb-0">
                <span class="text-gray-600">地点：</span>
                <span class="font-medium">广东省深圳市</span>
              </div>
              <div>
                <span class="text-gray-600">截止日期：</span>
                <span class="highlight-date">2024-06-30</span>
              </div>
            </div>
            <div class="amount-tag">
              <i class="fas fa-yuan-sign mr-1"></i> 标的金额：280万元
            </div>
          </div>
        </div>

        <!-- 招标信息卡片 2 -->
        <div class="result-card">
          <div class="status-badge active">招标中</div>
          <h2 class="text-xl font-bold text-blue-800 mb-2">2024中国（上海）国际医疗器械展览会搭建服务</h2>
          <div class="mb-3">
            <span class="category-tag">展位搭建</span>
            <span class="category-tag">医疗器械展</span>
          </div>
          <p class="text-gray-600 mb-4">为2024中国（上海）国际医疗器械展览会提供特装展位设计与搭建服务，包括主场搭建、特装展位设计施工、展会现场运营管理等。展会将集中展示医疗器械领域的最新产品和技术，预计规模达到8万平方米。</p>
          <div class="flex flex-wrap items-center justify-between">
            <div class="flex flex-wrap items-center mb-2 md:mb-0">
              <div class="mr-6 mb-2 md:mb-0">
                <span class="text-gray-600">发布单位：</span>
                <span class="font-medium">上海医疗器械行业协会</span>
              </div>
              <div class="mr-6 mb-2 md:mb-0">
                <span class="text-gray-600">地点：</span>
                <span class="font-medium">上海市浦东新区</span>
              </div>
              <div>
                <span class="text-gray-600">截止日期：</span>
                <span class="highlight-date">2024-07-15</span>
              </div>
            </div>
            <div class="amount-tag">
              <i class="fas fa-yuan-sign mr-1"></i> 标的金额：450万元
            </div>
          </div>
        </div>

        <!-- 招标信息卡片 3 -->
        <div class="result-card">
          <div class="status-badge expired">已截止</div>
          <h2 class="text-xl font-bold text-blue-800 mb-2">2024中国（广州）国际汽车展览会安保服务项目</h2>
          <div class="mb-3">
            <span class="category-tag">安保服务</span>
            <span class="category-tag">汽车展览</span>
          </div>
          <p class="text-gray-600 mb-4">为2024中国（广州）国际汽车展览会提供全面的安保服务，包括展会现场安全保卫、人员及物品安检、应急事件处理等。展会将展示国内外主流汽车品牌的最新车型和技术，预计参观人数超过60万人次。</p>
          <div class="flex flex-wrap items-center justify-between">
            <div class="flex flex-wrap items-center mb-2 md:mb-0">
              <div class="mr-6 mb-2 md:mb-0">
                <span class="text-gray-600">发布单位：</span>
                <span class="font-medium">广州国际汽车展览有限公司</span>
              </div>
              <div class="mr-6 mb-2 md:mb-0">
                <span class="text-gray-600">地点：</span>
                <span class="font-medium">广东省广州市</span>
              </div>
              <div>
                <span class="text-gray-600">截止日期：</span>
                <span class="highlight-date">2024-05-20</span>
              </div>
            </div>
            <div class="amount-tag">
              <i class="fas fa-yuan-sign mr-1"></i> 标的金额：320万元
            </div>
          </div>
        </div>

        <!-- 招标信息卡片 4 -->
        <div class="result-card">
          <div class="status-badge expired">已截止</div>
          <h2 class="text-xl font-bold text-blue-800 mb-2">2024中国国际服务贸易交易会物流运输服务</h2>
          <div class="mb-3">
            <span class="category-tag">物流服务</span>
            <span class="category-tag">贸易展览</span>
          </div>
          <p class="text-gray-600 mb-4">为2024中国国际服务贸易交易会提供展品物流运输服务，包括展品的集中运输、仓储管理、现场装卸等。服贸会是全球服务贸易领域规模最大的综合性展会，预计将有来自150多个国家和地区的企业参展。</p>
          <div class="flex flex-wrap items-center justify-between">
            <div class="flex flex-wrap items-center mb-2 md:mb-0">
              <div class="mr-6 mb-2 md:mb-0">
                <span class="text-gray-600">发布单位：</span>
                <span class="font-medium">中国国际服务贸易交易会组委会</span>
              </div>
              <div class="mr-6 mb-2 md:mb-0">
                <span class="text-gray-600">地点：</span>
                <span class="font-medium">北京市朝阳区</span>
              </div>
              <div>
                <span class="text-gray-600">截止日期：</span>
                <span class="highlight-date">2024-05-10</span>
              </div>
            </div>
            <div class="amount-tag">
              <i class="fas fa-yuan-sign mr-1"></i> 标的金额：580万元
            </div>
          </div>
        </div>

        <!-- 招标信息卡片 5 -->
        <div class="result-card">
          <div class="status-badge active">招标中</div>
          <h2 class="text-xl font-bold text-blue-800 mb-2">2024中国（杭州）国际电子商务博览会主场运营服务</h2>
          <div class="mb-3">
            <span class="category-tag">主场运营</span>
            <span class="category-tag">电子商务</span>
          </div>
          <p class="text-gray-600 mb-4">为2024中国（杭州）国际电子商务博览会提供主场运营服务，包括展会整体策划、现场管理、嘉宾邀请、论坛组织等。博览会将聚焦数字经济和电子商务最新发展趋势，预计吸引超过300家企业参展。</p>
          <div class="flex flex-wrap items-center justify-between">
            <div class="flex flex-wrap items-center mb-2 md:mb-0">
              <div class="mr-6 mb-2 md:mb-0">
                <span class="text-gray-600">发布单位：</span>
                <span class="font-medium">杭州市电子商务协会</span>
              </div>
              <div class="mr-6 mb-2 md:mb-0">
                <span class="text-gray-600">地点：</span>
                <span class="font-medium">浙江省杭州市</span>
              </div>
              <div>
                <span class="text-gray-600">截止日期：</span>
                <span class="highlight-date">2024-07-25</span>
              </div>
            </div>
            <div class="amount-tag">
              <i class="fas fa-yuan-sign mr-1"></i> 标的金额：360万元
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  name: "Ztbxx"
}
</script>

<style scoped>

.bg-gradient-primary {
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  border-radius: 20px 20px 0px 0px;
  margin-bottom: 20px;
}
.page-content{
  padding-top: 20px;
  padding-bottom: 20px;
}
body {
  font-family: 'Noto Sans SC', sans-serif;
  background-color: #f5f7fa;
  color: #2d3748;
}

.container {
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 1rem;
}

.nav-button {
  transition: all 0.3s ease;
  border-radius: 8px;
  padding: 1.5rem 2rem;
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.nav-button.active {
  background-color: #1e40af;
  color: white;
}

.nav-button i {
  font-size: 2.5rem;
  margin-bottom: 0.75rem;
}

.nav-button span {
  font-size: 1.25rem;
  font-weight: 600;
}

.nav-button p {
  font-size: 0.875rem;
  margin-top: 0.5rem;
  opacity: 0.9;
}

.search-bar {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.filter-bar {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.result-card {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  position: relative;
}

.status-badge {
  position: absolute;
  top: 1rem;
  right: 1rem;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
}

.status-badge.active {
  background-color: #10b981;
  color: white;
}

.status-badge.expired {
  background-color: #ef4444;
  color: white;
}

.category-tag {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background-color: #dbeafe;
  color: #1e40af;
  border-radius: 9999px;
  font-size: 0.875rem;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
}

.highlight-date {
  font-weight: 600;
  color: #1e40af;
}

.amount-tag {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background-color: #f0f9ff;
  color: #0369a1;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
}

.select-style {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2394a3b8'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  background-size: 1.5em 1.5em;
}

@media (max-width: 1200px) {
  .nav-button {
    width: 250px;
  }
}

@media (max-width: 768px) {
  .nav-buttons-container {
    flex-direction: column;
    align-items: center;
  }

  .nav-button {
    width: 100%;
    max-width: 400px;
    margin-bottom: 1rem;
  }
}
</style>
